import React from "react";
import SlidingPane from "react-sliding-pane";
import "react-sliding-pane/dist/react-sliding-pane.css";
import { Button, Typography, Container, Grid, Hidden } from "@mui/material";
import { styled } from "@mui/system";
import { makeStyles } from "@mui/styles";

const StyledHeader = styled("div")(({ theme }) => ({
  background: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(2),
  textAlign: "center",
}));

const useStyles = makeStyles((theme) => ({
  headerText: {
    marginBottom: theme.spacing(0.5),
    color: "rgb(29, 66, 138)",
  },
}));

const SlidingPaneComponent = React.memo(
  ({ isOpen, title, subtitle, onRequestClose, children, isHideHeader }) => {
    const classes = useStyles();
    return (
      <SlidingPane
        className="slider-pane"
        overlayClassName="slider-pane-overlay"
        isOpen={isOpen}
        title={
          <Grid container justify="space-between" alignItems="center">
            <Grid item xs={6}>
              <Typography
                variant="h6"
                className={`${classes.headerText} headerTitle`}
              >
                {title}
              </Typography>
            </Grid>
            <Grid item xs={6} style={{ textAlign: "right" }}>
              <Hidden mdUp>
                <Button
                  onClick={onRequestClose}
                  variant="outlined"
                  color="primary"
                >
                  Close
                </Button>
              </Hidden>
            </Grid>
          </Grid>
        }
        subtitle={subtitle}
        onRequestClose={onRequestClose}
        width="95%"
        hideHeader={isHideHeader}
      >
        {children}
      </SlidingPane>
    );
  }
);

export default SlidingPaneComponent;
